const LAST_VISIT_KEY = "lastVisit";

export const setLastVisit = () => {
  localStorage.setItem(LAST_VISIT_KEY, new Date().getTime());
};

export const getLastVisit = () => {
  return localStorage.getItem(LAST_VISIT_KEY);
};
